<script lang="ts">
  import type { SVGAttributes } from "svelte/elements";

  interface Props extends SVGAttributes<SVGSVGElement> {
    size?: number;
    thin?: boolean;
    color?: string;
    class?: string;
    style?: string;
  }

  const shapeRendering = "geometricPrecision";

  let {
    size = 16,
    thin = false,
    color = "var(--color-pri-800)",
    class: className = "",
    style = "",
    ...rest
  }: Props = $props();
</script>

<svg
  height={size}
  width={size}
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 16 16"
  class={className}
  style="color: var(--color-pri-800); {style}"
  {...rest}
>
  <g fill="none" stroke={color} stroke-width={thin ? "1" : "1.25"}>
    <path
      d="m5.69453 3.13655c-1.10685 2.00525-3.24208 3.36345-5.69453 3.36345-3.3055 0-6.03472-2.46739-6.44633-5.660858"
      stroke-linecap="round"
      transform="translate(8 8)"
      shape-rendering={shapeRendering}
    />
    <path
      d="m-1.58094 3.29533 3.06568-6.20589"
      stroke-linecap="round"
      transform="translate(6.76844 10.4859)"
      shape-rendering={shapeRendering}
    />
    <g stroke-linejoin="round" transform="translate(12.5806 6.58736)">
      <path
        d="m-1.99081 2.7352s.49173-1.2007.64378-3.284757c.16738-2.294263-.27257-3.795403-.27257-3.795403s2.354017.87707 3.23354 3.795403c.83668 2.776187-.37829 4.855897-.37829 4.855897s-.454302-.97876-1.3203706-1.44369c-.8660684-.46493-1.9060894-.12745-1.9060894-.12745z"
        shape-rendering={shapeRendering}
      />
      <path
        d="m-7.05252.0632348s.54796-1.1430648 1.7468-2.2725448c1.60644-1.51349 3.71509-2.14531 3.71509-2.14531s.33951 1.28014.2436 3.46839c-.09307 2.12337-.64377 3.62143-.64377 3.62143s-1.16595-1.748299-2.24043-2.213229c-1.07449-.4649296-2.82129-.4587362-2.82129-.4587362z"
        shape-rendering={shapeRendering}
      />
      <path
        d="m-10.3785-1.50791s.5483-1.41704 2.20958-2.50061c3.38698-2.20915 6.63621-.31713 6.63621-.31713s-1.87521.43298-3.75822 2.17289c-.855.79002-1.76159 2.2159948-1.76159 2.2159948s-.48487-.8532728-1.2993-1.2887548c-.81443-.43549-2.02668-.28239-2.02668-.28239z"
        shape-rendering={shapeRendering}
      />
    </g>
  </g>
</svg>
